import { createStore, compose, applyMiddleware } from 'redux';
import { routerMiddleware } from 'react-router-redux';
import { browserHistory } from 'react-router';
import thunk from 'redux-thunk';
import refreshTokenMiddleware from './middleware/refreshToken';
import analyticsMiddleware from './middleware/analytics';
import rootReducerFunc from "../reducers";

const middleware = routerMiddleware(browserHistory);

export default function configureStore(initialState) {
  const rootReducer = rootReducerFunc();
  const store = createStore(
    rootReducer,
    initialState,
    compose(
      applyMiddleware(thunk, middleware, analyticsMiddleware, refreshTokenMiddleware)
    )
  );

  return store;
}



// WEBPACK FOOTER //
// ./src/store/configureStore.prod.js